"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PageHeaderModule = _interopRequireDefault(require("./PageHeader.module.scss"));

var _wisetackLogo = _interopRequireDefault(require("@wisetack/assets/img/wisetack-logo.svg"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function PageHeader(_ref) {
  var progress = _ref.progress,
      onClose = _ref.onClose,
      onBack = _ref.onBack,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col"
  }, progress ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "progress",
    style: {
      backgroundColor: "#ffe7dc",
      marginTop: "15px"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "progress",
    className: "progress-bar progress-bar-warning",
    style: {
      width: progress
    }
  })) : /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      paddingTop: "15px"
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col"
  }, onBack && /*#__PURE__*/_react["default"].createElement("div", {
    className: _PageHeaderModule["default"].back,
    onClick: onBack
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "material-icons"
  }, "arrow_back"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: _PageHeaderModule["default"].logo,
    src: _wisetackLogo["default"],
    alt: "wisetack-logo"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col"
  }, onClose && /*#__PURE__*/_react["default"].createElement("div", {
    className: _PageHeaderModule["default"].close,
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "material-icons"
  }, "close")))), children && children.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: _PageHeaderModule["default"].title
  }, children[0]), children && children.length > 1 && /*#__PURE__*/_react["default"].createElement("div", {
    className: _PageHeaderModule["default"].subtitle
  }, children[1])));
}

PageHeader.propTypes = {
  progress: _propTypes["default"].string.isRequired
};
var _default = PageHeader;
exports["default"] = _default;